import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { RelatedPortfolioLike } from "web_myplann/Portfolio/Helpers/relatedItemLike";

export const relatedPortfolioLabel = (
	relatedPortfolio: RelatedPortfolioLike,
	t: ReturnType<typeof useResource>["t"],
): string => {
	if (relatedPortfolio.name) {
		return relatedPortfolio.name;
	}
	const { product, contractNumber, domain } = relatedPortfolio;
	if (product && contractNumber) {
		return `${product} (${contractNumber})`;
	}
	if (product || contractNumber) {
		return product || contractNumber || "";
	}
	return t(Resources.Portfolio.List.PortfolioDomainType[domain]);
};
